import styled from '@emotion/styled'
import { Box, Text } from 'theme-ui'

import media from './../../../common/MediaQueries'

const HeadingStyled = styled(Box)``

const HeadingBlockStyled = styled(Text)`
  text-align: center;
  @media ${media.tablet} {
    ${({ theme }) => (theme.direction === 'rtl' ? 'text-align: right;' : 'text-align: left;')}
  }
`

const HeadingCtaStyled = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  @media ${media.tablet} {
    justify-content: flex-start;
  }
`

export { HeadingStyled, HeadingBlockStyled, HeadingCtaStyled }
